import { render, staticRenderFns } from "./TrueFalseResult.vue?vue&type=template&id=747778fe&"
import script from "./TrueFalseResult.vue?vue&type=script&lang=js&"
export * from "./TrueFalseResult.vue?vue&type=script&lang=js&"
import style0 from "./TrueFalseResult.vue?vue&type=style&index=0&id=747778fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports